import root from './_root.js';

/** Built-in value references. */
var Symbol = root.Symbol;

export default Symbol;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/lodash-es/_Symbol.js
// module id = mVZR
// module chunks = 1